<nb-card class="card-scroll">
	<nb-card-header class="card-header-title">
		<div class="card-header-title">
			<ngx-back-navigation></ngx-back-navigation>
			<h4> <ngx-header-title> {{ 'MENU.SCHEDULES' | translate }} </ngx-header-title> </h4>
		</div>
	</nb-card-header>
	<nb-card-body>
		<nb-route-tabset [tabs]="tabs"></nb-route-tabset>
	</nb-card-body>
</nb-card>
